























import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class ImageButton extends Vue {
    @Prop() private userConfigColor! : string;

    setIsSelectImageVisible(){
        this.$emit("setIsSelectImageVisible");
    }
}
